import { render } from "./detailOffre.vue?vue&type=template&id=478be608&scoped=true"
import script from "./detailOffre.vue?vue&type=script&lang=js"
export * from "./detailOffre.vue?vue&type=script&lang=js"

import "./detailOffre.vue?vue&type=style&index=0&id=478be608&scoped=true&lang=css"

import exportComponent from "/home/andre/Bureau/projets-nexah/web/vuejs/web/cv-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478be608"]])

export default __exports__